import { createSvgIcon } from '@mui/material/utils';

const Close = createSvgIcon(
    <svg viewBox="0 -960 960 960">
        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>,
    'Close'
);

export { Close };
